module.exports = __webpack_public_path__ + "img/28.4733e178.jpg";